import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(LocalizedFormat)

export function dateTimeFormatters () {
  const formatDateWithLocale = (date, locale, format) => {
    return dayjs(date).locale(locale).format(format)
  }
  const formatCurrentDateWithLocale = (locale, format) => {
    return dayjs().locale(locale).format(format)
  }
  const formatDateUnix = (date, format) => {
    return dayjs.unix(date).format(format)
  }
  const dateIsAfterOfCurrentDate = (date) => {
    return dayjs().isAfter(dayjs(date))
  }
  const dateIsBeforeOfCurrentDate = (date) => {
    return dayjs().isBefore(dayjs(date))
  }
  const formatDate = (date, format) => {
    return dayjs(date).format(format)
  }
  const dateStartOf = (date, format, startOf) => {
    return dayjs(date.substring(0, 10), { format: format }).startOf(startOf)
  }
  const currentdateStartOf = (startOf) => {
    return dayjs().startOf(startOf)
  }
  return {
    formatDateWithLocale,
    formatCurrentDateWithLocale,
    formatDateUnix,
    dateIsAfterOfCurrentDate,
    dateIsBeforeOfCurrentDate,
    formatDate,
    dateStartOf,
    currentdateStartOf
  }
}
